import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import { AlumnoContextProvider } from "./context/alumnoContext";
import { ProgressSpinner } from "primereact/progressspinner";

import Login from './pages/Login/Login';
import ActualizarContrasena from "./pages/Login/ActualizarContrasena";
import RecuperarContrasena from "./pages/Login/RecuperarContrasena";
import Home from './pages/Home/Home';
import { PrivateRoutes, PublicRoutes } from "./routes/routes";

import ConsultaDocenteNova from './pages/Login/ConsultaDocenteNova'; //esv
import { interceptStorageEvents } from './services/storageEvents'; //esv


import ValidateCertificateQR from "././pages/components/ValidateCertificate/ValidateCertificateQR";

//const Login = lazy(() => import("./pages/Login/Login"));
//const Home = lazy(() => import("./pages/Home/Home"));
//const Home = lazy(() => import("./pages/private/Home/Home"));

const jwt = window.localStorage.getItem("jwt");

function App() {

  const [jwt, setJwt] = useState('');      
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState('');
  const [domain, setDomain] = useState('campus.zegelvirtual.com');

  const CONFIG = {
    apiUrl: process.env.REACT_APP_API_URL,
    apiKey: process.env.REACT_APP_API_KEY,
    companyId: process.env.REACT_APP_COMPANY_ID,
  };
  
  useEffect(() => {
    interceptStorageEvents();    

    const storedJwt = window.localStorage.getItem("jwt");
    const nombre = window.localStorage.getItem("nombre");
    const id = window.localStorage.getItem("userId");

    setJwt(storedJwt);
    setIsLoggedIn(Boolean(storedJwt));
    setUserName(nombre || '');
    setUserId(id || '');
    setDomain(typeof window !== 'undefined' ? window.location.hostname : 'campus.zegelvirtual.com');

    const handleJwtUpdate = () => {
      const updatedJwt = window.localStorage.getItem('jwt');
      setJwt(updatedJwt);
      setIsLoggedIn(Boolean(updatedJwt));
    };

    window.addEventListener('jwt-updated', handleJwtUpdate);

    return () => {
      window.removeEventListener('jwt-updated', handleJwtUpdate);
    };

  }, []);

  if (!jwt) {
    console.log("No hay token, usuario no logueado");
  } else {
    console.log("Token encontrado, usuario logueado");
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const token = window.localStorage.getItem("jwt");
      setIsLoggedIn(Boolean(token));

      // Puedes traer más datos de localStorage si los guardas (userName, userId)
      const storedUserName = window.localStorage.getItem("userName");
      const storedUserId = window.localStorage.getItem("userId");
      if (storedUserName) setUserName(storedUserName);
      if (storedUserId) setUserId(storedUserId);
    }, 1000); // revisa cada 1 segundo si cambia el login

    return () => clearInterval(interval); // limpieza
  }, []);
  //end esv

  return (
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <AlumnoContextProvider>
          <Routes>
            
            <Route path="/ValidateCertificateQR" element={<ValidateCertificateQR />} />

            <Route
              path="/"
              element={
                isLoggedIn ? (
                  <Navigate
                    to={PrivateRoutes.HOME + "/" + PrivateRoutes.DASHBOARD}
                  />
                ) : (
                  <Navigate to={PublicRoutes.LOGIN} />
                )
              }
            />
            <Route path={PublicRoutes.LOGIN} element={<Login />} />
            <Route path={PublicRoutes.RECUPERAR} element={<RecuperarContrasena />} />
            <Route path={PublicRoutes.RECUPERAR + "/:guid"} element={<ActualizarContrasena />} />
            <Route path={PrivateRoutes.HOME + "/*"} element={<Home />} />
          </Routes>
        </AlumnoContextProvider>
      </Suspense>
      {isLoggedIn && (
        <ConsultaDocenteNova
          apiUrl={process.env.REACT_APP_API_URL}
          apiKey={process.env.REACT_APP_API_KEY}
          domain={domain}
          companyId={process.env.REACT_APP_COMPANY_ID}
          userName={userName}
          userId={userId}
        />
      )}
    </BrowserRouter>
    
  );
}
export default App;